module.exports = __webpack_public_path__ + "static/media/feedbackIcon.6aece745.svg";